module.exports = "[General]\nName={{streamName}}\n\n[Output]\nMode=Advanced\n\n[SimpleOutput]\nUseAdvanced=false\n\n[AdvOut]\nRescaleRes=2880x1800\nTrackIndex=1\nRecType=Standard\nRecRescaleRes=2880x1800\nRecTracks=1\nFFOutputToFile=true\nFFRescaleRes=2880x1800\nFFVEncoderId=0\nFFAEncoderId=0\nFFAudioTrack=1\nApplyServiceSettings=true\nFFFormat=\nFFFormatMimeType=\nFFVEncoder=\nFFAEncoder=\nTrack1Bitrate={{audioBitrateKbps}}\n\n[Video]\nBaseCX={{width}}\nBaseCY={{height}}\nOutputCX={{width}}\nOutputCY={{height}}\n"


//////////////////
// WEBPACK FOOTER
// ./app/pages/events/obs-basic-template.ini
// module id = 400
// module chunks = 3